<template>
   <div class="teaching-detail">
        <!-- <HeaderTop></HeaderTop> -->
        <!-- <Header :page="0"></Header> -->
         <el-breadcrumb separator="/" class="bread-crumb main">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/list/teaching' }">考试教材</el-breadcrumb-item>
            <el-breadcrumb-item >{{book.bookname}}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="teaching-detail-box main "  @click="botton">
            <div class="detail-top flex-layout">
                <div class="detail-top-left">
                    <img :src="listimage[$route.params.id].cover" alt="" />
                </div>
                <div class="detail-top-right">
                  <p>{{book.bookname}}</p>
                  <p>编著：{{book.editor}}</p>
                  <p class="flex-layout"><span>出版社：{{book.press}} </span> <span>出版时间：{{book.edition}}</span></p>
                  <p class="flex-layout"><span>SBN：{{book.booknumber}}</span> <span>开本：{{book.booksize}}开</span></p>
                  <p style="font-size: 26px;font-family: Source Han Sans CN;font-weight: 400;color: #CC4C4D;">¥{{book.price}}</p>
                   <el-button class="botton" @click.stop="botton" type="danger">在哪买这本书<i class="el-icon--right el-icon-arrow-down"></i></el-button>
                  <!-- <div class="botton">在哪买这本书<span> &gt;</span></div> -->
                  <div v-if="popupshow" class="popup ">
                      <img :src="QRcode[$route.params.id].cover" alt="">
                    <div>微信扫一扫</div>
                    
                  </div>
                </div>
            </div>
            <div class="detail-bottom flex-layout">
                <div class="detail-bottom-left">
                  <div class="head-top">目录 <div class="heng width70"></div></div>
                  <div class="tree">
	                    <!-- default-expand-all -->
                    <el-tree :data="book.list"
                     :props="defaultProps"                   
                      accordion 
	                    node-key
	                    :highlight-current="true"
	                    :expand-on-click-node="false"
                       @node-click="handleNodeClick"></el-tree>
                  </div>
                </div>
                <div class="detail-bottom-right">
                  <div class="books-top">
                     <div class="head-top">内容简介 <div class="heng width150"></div></div>
                     <p>{{book.contentintroduction}}</p>
                  </div>
                  <div class="books-center">
                     <div class="head-top">作者介绍 <div class="heng width150"></div></div>
                     <div class="books-center-bottom flex-align">
                       <!-- <img :src="book.authorimage" alt=""> -->
                       <p>{{book.authorintroduction}}</p>
                     </div>
                  </div>
                  <div class="books-bottom">
                     <div class="head-top">内容预览 <div class="heng width150"></div></div>
                     <div class="books-bottom-bom">
                       <el-carousel height="400px" indicator-position="outside">
                        <el-carousel-item   v-for="(item,index) in imagelist[$route.params.id]" :key="index">
                          <img :src="item.cover" alt="" />
                        </el-carousel-item>
                      </el-carousel>
                       
                       </div>
                  </div>
                </div>
            </div>
        </div> 
           
        <footer-view></footer-view>
    </div>
</template>

<script>
import booksJSON from './js/books.json'
export default {
    data() {
        return {
          defaultProps: {
            children: 'children',
            label: 'label'
          },
          book:{
            bookname:"",
            booknumber:"",
            editor:"",
            price:"",
            booksize:"",
            press:"",
            edition:"",
            wordnumber:"",
            authorintroduction:"",
            contentintroduction:"",
          },
          popupshow:false,
          listimage:{
           175:{
              cover:require(`./js/img/header/175.jpeg`)
            },
            160:{
              cover:require(`./js/img/header/160.jpeg`)
            },
            110:{
              cover:require(`./js/img/header/110.jpeg`)
            },
            174:{
              cover:require(`./js/img/header/174.jpeg`)
            },
            162:{
              cover:require(`./js/img/header/162.jpeg`)
            },
            163:{
              cover:require(`./js/img/header/163.jpeg`)
            },
            111:{
              cover:require(`./js/img/header/111.jpeg`)
            },
            172:{
              cover:require(`./js/img/header/172.jpeg`)
            },
            173:{
              cover:require(`./js/img/header/173.jpeg`)
            },
            161:{
              cover:require(`./js/img/header/161.jpeg`)
            },
          },
          QRcode:{
            175:{
              cover:require(`./js/img/qr/maobi79.png`)
            },
            160:{
              cover:require(`./js/img/qr/donghua.png`)
            },
            110:{
              cover:require(`./js/img/qr/maobi13.png`)
            },
            174:{
              cover:require(`./js/img/qr/maobi46.png`)
            },
            162:{
              cover:require(`./js/img/qr/secai19.png`)
            },
            163:{
              cover:require(`./js/img/qr/sumiao19.png`)
            },
            111:{
              cover:require(`./js/img/qr/yingbi13.png`)
            },
            172:{
              cover:require(`./js/img/qr/yingbi46.png`)
            },
            173:{
              cover:require(`./js/img/qr/yingbi79.png`)
            },
            161:{
              cover:require(`./js/img/qr/guohua.png`)
            },
          },
          imagelist:{
            175:[
                {
                  cover:require(`./js/img/maobi79/1.jpg`)
              }, {
                  cover:require(`./js/img/maobi79/2.jpg`)
              }, {
                  cover:require(`./js/img/maobi79/3.jpg`)
              }, {
                  cover:require(`./js/img/maobi79/4.jpg`)
              }
            ],
            160:[
                {
                  cover:require(`./js/img/donghua/1.jpg`)
              }, {
                  cover:require(`./js/img/donghua/2.jpg`)
              }, {
                  cover:require(`./js/img/donghua/3.jpg`)
              }, {
                  cover:require(`./js/img/donghua/4.jpg`)
              }
            ],
            110:[
                {
                  cover:require(`./js/img/maobi13/1.jpg`)
              }, {
                  cover:require(`./js/img/maobi13/2.jpg`)
              }, {
                  cover:require(`./js/img/maobi13/3.jpg`)
              }, {
                  cover:require(`./js/img/maobi13/4.jpg`)
              }
            ],
            174:[
                {
                  cover:require(`./js/img/maobi46/1.jpg`)
              }, {
                  cover:require(`./js/img/maobi46/2.jpg`)
              }, {
                  cover:require(`./js/img/maobi46/3.jpg`)
              }, {
                  cover:require(`./js/img/maobi46/4.jpg`)
              }
            ],
            162:[
                {
                  cover:require(`./js/img/secai19/1.jpg`)
              }, {
                  cover:require(`./js/img/secai19/2.jpg`)
              }, {
                  cover:require(`./js/img/secai19/3.jpg`)
              }, {
                  cover:require(`./js/img/secai19/4.jpg`)
              }
            ],
            163:[
                {
                  cover:require(`./js/img/sumiao19/1.jpg`)
              }, {
                  cover:require(`./js/img/sumiao19/2.jpg`)
              }, {
                  cover:require(`./js/img/sumiao19/3.jpg`)
              }, {
                  cover:require(`./js/img/sumiao19/4.jpg`)
              }
            ],
            111:[
                {
                  cover:require(`./js/img/yingbi13/1.jpg`)
              }, {
                  cover:require(`./js/img/yingbi13/2.jpg`)
              }, {
                  cover:require(`./js/img/yingbi13/3.jpg`)
              }, {
                  cover:require(`./js/img/yingbi13/4.jpg`)
              }
            ],
            172:[
                {
                  cover:require(`./js/img/yingbi46/1.jpg`)
              }, {
                  cover:require(`./js/img/yingbi46/2.jpg`)
              }, {
                  cover:require(`./js/img/yingbi46/3.jpg`)
              }, {
                  cover:require(`./js/img/yingbi46/4.jpg`)
              }
            ],
            173:[
                {
                  cover:require(`./js/img/yingbi79/1.jpg`)
              }, {
                  cover:require(`./js/img/yingbi79/2.jpg`)
              }, {
                  cover:require(`./js/img/yingbi79/3.jpg`)
              }, {
                  cover:require(`./js/img/yingbi79/4.jpg`)
              }
            ],
            161:[
                {
                  cover:require(`./js/img/guohua/1.jpg`)
              }, {
                  cover:require(`./js/img/guohua/1.jpg`)
              }, {
                  cover:require(`./js/img/guohua/1.jpg`)
              }, {
                  cover:require(`./js/img/guohua/1.jpg`)
              }
            ],

          }
        }
    },
    computed:{
    },
    methods: { 
      botton() {
        this.popupshow =!this.popupshow;
        console.log(this.popupshow)
      },
      handleNodeClick(data) {
      },
        bookmap(id) {
         
          this.book =booksJSON.books[id];
          console.log(this.book)
        }
    },
    mounted() {
      this.bookmap(this.$route.params.id)
    },
    beforeDestroy() {
   
}
}
</script>

<style lang="less" scoped>
 @import "./less/news_common.less";
  @white:#fff;
  .teaching-detail {
    background-color: @white;

    .main {
        width: 1200px;
        margin: 0 auto;
    }
    .teaching-detail-box {
        .detail-top {
          background: #FFFDFE;
          border: 1px solid #E9E9E9;
          padding:35px 0 40px 38px;
          border-radius: 5px;
          position: relative;

          .detail-top-left {
            // border: 1px solid #E9E9E9;
            width: 227px;
            img {
              // width:227px;
              width:100%;
              height:227px;
            }
          }
          .detail-top-right {
            padding-left:63px;
            .botton {
              position:absolute;
              bottom:40px;
              right:40px;
              background: #CC4C4D;
              // padding:7px 20px;
              // font-size: 14px;
              // font-family: Source Han Sans CN;
              // font-weight: 400;
              // color: #FFFFFF;
              // border-radius: 8px;
             

            }
            .popup {
              position:absolute;
              text-align: center;
              z-index: 9999;
              bottom:-120px;
              right:50px;
              border:1px solid #c9c6c6;
              padding:10px;
              background: #fff;
              color: #CC4C4D;
              img {
                width: 100px;
                height: 100px;
              }
            }
            p {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 300;
              color: #999999;
              padding-bottom:30px;
              &:first-child{
                font-size: 22px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #333333;
              }
             
                span:nth-child(1) {
                 flex:3;
                }
                span:nth-child(2) {
                 flex:2;
                }
              //    &:last-child {
                
              // }
            }
            p:last-child {
            font-size: 26px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #CC4C4D;
          }
            
          }
        }
        .detail-bottom {
          padding:30px 0;
          // height: 700px;
          
          .head-top {
            position: relative;
            height: 55px;
            line-height: 55px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            padding:0 10px;
            border-bottom:1px solid #E6E6E6;
            .heng {
              position: absolute;
              bottom:-3px;
              left:0;
              height: 5px;
              background: #CC4C4D;
            }
            .width100{
              width:100px;
            }
            .width70{
              width:70px;
            }
            .width150{
              width:150px;
            }
            .width200{
              width:200px;
            }

          }
          .detail-bottom-left {
            flex: 1;
            background: #FFFDFE;
            border: 1px solid #E9E9E9;
            .tree {
              padding:30px 25px;
             /deep/ .el-tree-node {
                white-space: normal;
                .el-tree-node__content {
                  height: 100%;
                  align-items: start;
                }
              }
            }

          }
          .detail-bottom-right{
            flex:4;
            margin-left:25px;
            .books-top{
              background: #FFFDFE;
              border: 1px solid #E9E9E9;
              margin-bottom:33px;
              border-radius: 5px;
              p {
                padding:42px 65px;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #999999;
                line-height: 36px;
                
              }

              

            } 
            .books-center{
              background: #FFFDFE;
              border: 1px solid #E9E9E9;
              margin-bottom:33px;
              border-radius: 5px;
              .books-center-bottom {
                padding:25px 60px;
                img {
                  width: 153px;
                  height: 192px;
                  border-radius: 10px;
                }
                p {
                  // padding-left:50px;
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #999999;
                    line-height: 36px;
                }

              }

            } 
            .books-bottom{
              background: #FFFDFE;
              border: 1px solid #E9E9E9;
              border-radius: 5px;
              .books-bottom-bom {
                padding:46px 136px;
                // width: 100%;
                img {
                  display: block;
                  margin: 0 auto;
                  width: 50%;
                  height: 100%;
                  
                }
                
              }
            }
          }
        }
    }
     
    
  }
</style>